<template>
  <div>
    <vt-grid
      class="comp-grid my-1"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :dom-layout="domLayout"
    />
  </div>
</template>

<script>
import VtGrid from '@/components/VtGrid/VtGrid'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import complementariesService from '@/api/resources/common/complementaryServices'
import CellGridRichText from '@/components/common/CellGridRichText'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

export default {
    name: 'PatientComplementariesTab',
    components: { VtGrid },
    props: {
        casId: { type: Number, required: true }
    },
    data() {
        return {
            domLayout: 'autoHeight',
            rowData: [],
            columnDefs: [
                {
                    type: 'text',
                    headerName: this.$t('component.modalPatientCases.pathologist'),
                    colId: 'caseStudy.pathologist.name',
                    field: 'caseStudy.pathologist.name',
                    minWidth: 100
                },
                {
                    type: 'text',
                    headerName: this.$t('component.modalPatientCases.description'),
                    colId: 'complementaryInformation.text',
                    field: 'complementaryInformation.text',
                    cellStyle: { 'white-space': 'normal', 'overflow-y': 'auto' },
                    cellRendererFramework: CellGridRichText,
                    minWidth: 480,
                    width: 500
                },
                {
                    type: 'dateTime',
                    headerName: this.$t('component.modalPatientCases.validationDate'),
                    colId: 'caseStudy.validationDate',
                    field: 'validationDate',
                    minWidth: 200
                },
                {
                    type: 'text',
                    headerName: this.$t('component.modalPatientCases.observations'),
                    colId: 'observations',
                    field: 'observations',
                    cellStyle: { 'white-space': 'normal', 'overflow-y': 'auto' },
                    cellRendererFramework: CellGridRichText,
                    minWidth: 480,
                    width: 500
                }
            ]
        }
    },
    computed: {
        gridOptions() {
            return {
                floatingFilter: false,
                pagination: false,
                sideBar: gridSideBarConfig,
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                getRowHeight: params => {
                    // assuming 30 characters per line, with 18 lines
                    const maxLength = Math.max(
                        params.data.observations ? params.data.observations.length : 0,
                        params.data.complementaryInformation.text ? params.data.complementaryInformation.text.length : 0
                    )
                    if (maxLength) {
                        let calc = 30 * (Math.floor(maxLength / 25) + 2)
                        if (calc > 200) calc = 200
                        return calc
                    } else {
                        return 20
                    }
                }
            }
        }
    },
    async mounted() {
        const [err, response] = await this.toCall(complementariesService.getComplementaries(this.$store.getters.labId, this.casId))
        if (err) {
            this.showErrorModalGlobal()
        }
        this.rowData = response
        this.$emit('complementariesCount', this.rowData.length)
    }
}
</script>

<style lang="scss">
.comp-grid .ag-body-viewport {
  overflow-y: auto !important;
  height: calc(100vh - 590px) !important;
}

@media (max-width: 1300px) {
  .comp-grid .ag-body-viewport {
    overflow-y: auto !important;
    height: calc(100vh - 530px) !important;
  }
}

@media only screen and (max-width: 1366px) and (min-width: 1360px) {
  .comp-grid .ag-body-viewport {
    overflow-y: auto !important;
    height: calc(100vh - 300px) !important;
  }
}
</style>
